module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container mb-4 p-sm-3 col-md-8"
  }, [_c('h1', [_vm._v("\n    お問い合わせ\n  ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "mb-5",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('div', {
    staticClass: "p-3"
  }, [_c('p', [_vm._v("講師番号")]), _vm._v(" "), _c('p', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.prof.lecturer_no))])]), _vm._v(" "), _c('div', {
    staticClass: "p-3"
  }, [_c('p', [_vm._v("講師名")]), _vm._v(" "), _c('p', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.prof.name))])]), _vm._v(" "), _c('div', {
    staticClass: "p-3"
  }, [_c('p', [_vm._v("メールアドレス")]), _vm._v(" "), _c('p', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.prof.email))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group p-3"
  }, [_c('label', {
    attrs: {
      "for": "Kind"
    }
  }, [_vm._v("協会への連絡種別")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inquiry_type),
      expression: "inquiry_type"
    }],
    ref: "inquiryType",
    staticClass: "form-control",
    attrs: {
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.inquiry_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("選んで下さい...")]), _vm._v(" "), _c('option', [_vm._v("事務局への報告・意見・依頼書")]), _vm._v(" "), _c('option', [_vm._v("講師用一般の問合せ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group p-3"
  }, [_vm._m(1), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inquiry),
      expression: "inquiry"
    }],
    ref: "inquiry",
    staticClass: "form-control",
    attrs: {
      "id": "inquiryContent",
      "aria-required": "true",
      "required": "",
      "placeholder": "お問合せ内容",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.inquiry)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inquiry = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "group"
    }
  }, [_c('button', {
    ref: "submit",
    staticClass: "btn btn-primary btn-lg text-white",
    attrs: {
      "type": "submit",
      "disabled": _vm.isSubmitDisabled
    }
  }, [_vm._v("送信する")])])]), _vm._v(" "), _c('p', {
    staticClass: "text-right mt-5"
  }, [_c('router-link', {
    attrs: {
      "to": "/mypage"
    }
  }, [_vm._v("マイページへのリンク")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "attention"
  }, [_vm._v("※")]), _vm._v("必須\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "inquiryContent"
    }
  }, [_vm._v("\n        内容"), _c('span', {
    staticClass: "attention"
  }, [_vm._v("※")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-001c231e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lecturer/Inquiry.vue
// module id = 313
// module chunks = 1